export function getAssumedServiceDuration(label) {
  const result = /([1-9])/.exec(label);

  if (!result?.length) {
    return 0;
  }

  return result[0];
}
